import { useEffect, useState } from 'react';
import { InteractionManager } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { isPhone, isWeb } from '@helpers';

export const useWaitForTransitionEnd = (): boolean => {
  const navigation = useNavigation();
  const [ready, setReady] = useState<boolean>(isWeb || isPhone);

  useEffect(() => {
    if (isWeb || isPhone) return;

    let handle: ReturnType<typeof InteractionManager.runAfterInteractions> | undefined;

    const unsubscribe = navigation.addListener('transitionEnd', (e: any) => {
      if (e.data?.closing) return;
      handle = InteractionManager.runAfterInteractions(() => setReady(true));
    });

    return () => {
      unsubscribe();
      handle?.cancel();
    };
  }, [navigation]);

  return ready;
};
